import { LANG } from '@/common/constants/language';
import { TMarket } from '@/common/constants/markets';
import { LanguageType } from '@/common/types/general';

export function getLanguagesForMarket(market?: TMarket): LanguageType[] {
  switch (market) {
    case 'pt':
      return [LANG.PT, LANG.EN];
    case 'es':
      return [LANG.ES, LANG.EN];
    case 'it':
      return [LANG.IT, LANG.EN];
    default:
      return [LANG.EN];
  }
}
